var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State, Getter } from "vuex-class";
import { DepartmentService } from "~/services/management-service/department.service";
import { Prop } from "vue-property-decorator";
import CommissionSet from '~/components/case-import/client-manage/commission-set.vue';
var ModifyOrganize = /** @class */ (function (_super) {
    __extends(ModifyOrganize, _super);
    function ModifyOrganize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 修改机构参数
        _this.editOrgModel = {
            deptField: "123",
            companyCode: "",
            deptName: "",
            deptStatus: "",
            description: "",
            id: 0,
            parentId: 0,
            deptType: "",
            performanceDetail: [],
            principalCode: '',
            principalName: '',
            principalId: ''
        };
        _this.commissionData = [];
        /**
         * 添加机构信息校验规则
         */
        _this.editOrganizeRules = {
            deptName: [{ required: true, message: "请输入机构名称", trigger: "blur" }]
        };
        _this.disabled = false;
        return _this;
    }
    Object.defineProperty(ModifyOrganize.prototype, "isShow", {
        get: function () {
            var _this = this;
            var list = ["TEL", "VISIT", 'LEGAL'];
            return list.find(function (v) { return v === _this.editOrgModel.deptType; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取要修改的当前行数据
     */
    ModifyOrganize.prototype.refresh = function () {
        var _this = this;
        Object.keys(this.editOrgModel).forEach(function (x) {
            if (_this.editData[x] !== undefined) {
                _this.editOrgModel[x] = _this.editData[x];
            }
        });
        this.disabled = this.editData.level > 8;
        this.commissionData = this.editOrgModel.performanceDetail;
    };
    ModifyOrganize.prototype.principalChange = function (val) {
        if (val) {
            var item = this.principalList.content.find(function (v) { return v.id === val; });
            this.editOrgModel.principalName = item.name;
            this.editOrgModel.principalCode = item.principalCode;
        }
        else {
            this.editOrgModel.principalName = '';
            this.editOrgModel.principalCode = '';
        }
    };
    ModifyOrganize.prototype.onClickAccount = function () {
        this.commissionData.push({
            overduePeriodStart: '',
            overduePeriodEnd: '',
            paymentAccountType: '',
            rate: '',
            id: ''
        });
    };
    /**
     * 关闭窗口
     */
    ModifyOrganize.prototype.close = function () {
        var form = this.$refs["editOrg"];
        form.resetFields();
        this.$emit("close");
        this.commissionData = [];
    };
    /**
     * 修改机构确认
     */
    ModifyOrganize.prototype.editOrganizeCommit = function () {
        var _this = this;
        this.editOrgModel.performanceDetail = this.commissionData;
        var form = this.$refs["editOrg"];
        form.validate(function (valid) {
            if (valid) {
                _this.editOrgModel.performanceDetail.map(function (v) {
                    if (Number(v.rate) > 100)
                        return _this.$message.error('绩效比例不能大于100');
                });
                _this.editOrgModel.deptField = "123";
                _this.departmentService.updateDepartment(_this.editOrgModel).subscribe(function (data) {
                    _this.$message.success("修改机构成功!");
                    // 刷新机构数
                    _this.$emit("refresh");
                    //   关闭dialog
                    _this.close();
                });
            }
        });
    };
    __decorate([
        Dependencies(DepartmentService)
    ], ModifyOrganize.prototype, "departmentService", void 0);
    __decorate([
        State
    ], ModifyOrganize.prototype, "companyList", void 0);
    __decorate([
        Getter
    ], ModifyOrganize.prototype, "isSupperAdmin", void 0);
    __decorate([
        State
    ], ModifyOrganize.prototype, "principalList", void 0);
    __decorate([
        Prop()
    ], ModifyOrganize.prototype, "editData", void 0);
    ModifyOrganize = __decorate([
        Component({
            components: {
                CommissionSet: CommissionSet
            }
        })
    ], ModifyOrganize);
    return ModifyOrganize;
}(Vue));
export default ModifyOrganize;
